// Updated Dashboard2.js with Creative Token system for shop purchases

import React, { useState, useRef, useEffect } from 'react';
import { 
  Home, 
  ShoppingBag, 
  Sparkles, 
  FolderOpen, 
  CreditCard, 
  User,
  Bell,
  Menu,
  X,
  CheckCircle,
  AlertCircle,
  Info,
  ShoppingCart,
  Trash2,
  Plus,
  Minus,
  ChevronDown,
  Loader,
  Download,
  Star,
  Tag,
  Coins
} from 'lucide-react';
import '../css/Dashboard2.css';
import redfibrelogo from '../Images/redfibre logo.png'
import creativetokens from '../Images/creativetokens.png'
import { Link, useNavigate } from 'react-router-dom';

// Import updated API services
import {
  authAPI,
  dashboardAPI,
  userAPI,
  projectsAPI,
  shopAPI,
  cartAPI,
  notificationsAPI,
  tokenAPI,
  subscriptionAPI,
  handleAPIError
} from '../services/api';

// Keep existing country codes data
const countryCodes = [
  { code: '+1', country: 'US', flag: '🇺🇸', name: 'United States' },
  { code: '+1', country: 'CA', flag: '🇨🇦', name: 'Canada' },
  { code: '+44', country: 'GB', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+91', country: 'IN', flag: '🇮🇳', name: 'India' },
  { code: '+86', country: 'CN', flag: '🇨🇳', name: 'China' },
  { code: '+81', country: 'JP', flag: '🇯🇵', name: 'Japan' },
  { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Germany' },
  { code: '+33', country: 'FR', flag: '🇫🇷', name: 'France' },
  { code: '+39', country: 'IT', flag: '🇮🇹', name: 'Italy' },
  { code: '+34', country: 'ES', flag: '🇪🇸', name: 'Spain' },
  { code: '+61', country: 'AU', flag: '🇦🇺', name: 'Australia' },
  { code: '+55', country: 'BR', flag: '🇧🇷', name: 'Brazil' },
  { code: '+7', country: 'RU', flag: '🇷🇺', name: 'Russia' },
  { code: '+82', country: 'KR', flag: '🇰🇷', name: 'South Korea' },
  { code: '+971', country: 'AE', flag: '🇦🇪', name: 'United Arab Emirates' },
  { code: '+966', country: 'SA', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: '+27', country: 'ZA', flag: '🇿🇦', name: 'South Africa' },
  { code: '+52', country: 'MX', flag: '🇲🇽', name: 'Mexico' },
  { code: '+65', country: 'SG', flag: '🇸🇬', name: 'Singapore' },
  { code: '+60', country: 'MY', flag: '🇲🇾', name: 'Malaysia' },
];

const Dashboard2 = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [showTokenPackages, setShowTokenPackages] = useState(false);

  
  // API Data States
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState(null);
  const [projects, setProjects] = useState([]);
  const [shopItems, setShopItems] = useState([]);
  const [cart, setCart] = useState({ items: [], total_token_price: 0, total_items: 0, can_afford: false });
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // NEW: Token-related states
  const [tokenPackages, setTokenPackages] = useState([]);
  const [myPurchases, setMyPurchases] = useState([]);
  const [tokenHistory, setTokenHistory] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  // Country code selector state (keep existing)
  const [selectedCountryCode, setSelectedCountryCode] = useState(countryCodes[3]);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [contactNumber, setContactNumber] = useState('');
  const [countrySearch, setCountrySearch] = useState('');

  // Subscription
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
  const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  
  const notificationRef = useRef(null);
  const cartRef = useRef(null);
  const countryDropdownRef = useRef(null);
  const navigate = useNavigate();

    // subscription 

  const loadSubscriptionPlans = async () => {
  try {
    const plans = await subscriptionAPI.getPlans();
    setSubscriptionPlans(plans);
  } catch (error) {
    console.error('Failed to load subscription plans:', error);
  }
};

// Load current subscription
const loadCurrentSubscription = async () => {
  try {
    const subscription = await subscriptionAPI.getCurrentSubscription();
    setCurrentSubscription(subscription);
  } catch (error) {
    console.error('Failed to load current subscription:', error);
  }
};

// Load subscription history
const loadSubscriptionHistory = async () => {
  try {
    const history = await subscriptionAPI.getSubscriptionHistory();
    setSubscriptionHistory(history);
  } catch (error) {
    console.error('Failed to load subscription history:', error);
  }
};

// Subscribe to a plan
const subscribeToPlan = async (planId) => {
  try {
    const result = await subscriptionAPI.subscribeToPlan(planId);
    await loadCurrentSubscription(); // Reload current subscription
    await loadUserProfile(); // Reload user profile to get updated plan
    await loadSubscriptionHistory(); // Reload history
    
    alert(`Successfully subscribed to ${result.plan_name}! Your plan is now active.`);
    setShowSubscriptionPlans(false);
  } catch (error) {
    setError(handleAPIError(error));
  }
};

// Cancel subscription
const cancelSubscription = async () => {
  if (window.confirm('Are you sure you want to cancel your subscription? You will lose access to premium features at the end of your billing period.')) {
    try {
      await subscriptionAPI.cancelSubscription();
      await loadCurrentSubscription();
      alert('Subscription cancelled successfully. You will have access until the end of your billing period.');
    } catch (error) {
      setError(handleAPIError(error));
    }
  }
};

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: Home },
    { id: 'shop', label: 'Shop', icon: ShoppingBag },
    { id: 'my-purchases', label: 'My Purchases', icon: Download },
    { id: 'recommendations', label: 'Recommendations', icon: Sparkles },
    { id: 'projects', label: 'Projects', icon: FolderOpen },
    { id: 'billing', label: 'Billing & Tokens', icon: CreditCard },
    { id: 'profile', label: 'Profile', icon: User }
  ];
  
  const mockData = {
  
    recommendations: [
      { id: 1, name: "AI Logo Generator", description: "Create stunning logos in minutes", image: "https://via.placeholder.com/300x180/f8f9fa/333?text=AI+Logo" },
      { id: 2, name: "Brand Guidelines Kit", description: "Complete branding toolkit", image: "https://via.placeholder.com/300x180/f8f9fa/333?text=Brand+Kit" },
      { id: 3, name: "Social Media Templates", description: "Ready-to-use social templates", image: "https://via.placeholder.com/300x180/f8f9fa/333?text=Social" }
    ],
  };

  // Check authentication on component mount
  useEffect(() => {
    if (!authAPI.isAuthenticated()) {
      navigate('/login');
      return;
    }
    
    loadInitialData();
  }, [navigate]);

  // Load all initial data
 const loadInitialData = async () => {
  setLoading(true);
  try {
    await Promise.all([
      loadUserProfile(),
      loadDashboardStats(),
      loadProjects(),
      loadShopItems(),
      loadCart(),
      loadNotifications(),
      loadTokenPackages(),
      loadMyPurchases(),
      loadSubscriptionPlans(),
      loadCurrentSubscription()
    ]);
  } catch (error) {
    setError(handleAPIError(error));
  } finally {
    setLoading(false);
  }
};


  // Load user profile
  const loadUserProfile = async () => {
    try {
      const profileData = await userAPI.getProfile();
      setUser(profileData);
      setContactNumber(profileData.profile.contact || '');
      
      if (profileData.profile.country_code) {
        const userCountry = countryCodes.find(c => c.code === profileData.profile.country_code);
        if (userCountry) {
          setSelectedCountryCode(userCountry);
        }
      }
    } catch (error) {
      console.error('Failed to load user profile:', error);
    }
  };

  // Load dashboard stats
  const loadDashboardStats = async () => {
    try {
      const statsData = await dashboardAPI.getStats();
      setStats(statsData);
    } catch (error) {
      console.error('Failed to load dashboard stats:', error);
    }
  };

  // Load projects
  const loadProjects = async () => {
    try {
      const projectsData = await projectsAPI.getProjects();
      setProjects(projectsData);
    } catch (error) {
      console.error('Failed to load projects:', error);
    }
  };

  // Load shop items
  const loadShopItems = async () => {
    try {
      const category = selectedCategory === 'all' ? null : selectedCategory;
      const shopData = await shopAPI.getShopItems(category);
      setShopItems(shopData);
    } catch (error) {
      console.error('Failed to load shop items:', error);
    }
  };

  // Load cart
  const loadCart = async () => {
    try {
      const cartData = await cartAPI.getCart();
      setCart(cartData);
    } catch (error) {
      console.error('Failed to load cart:', error);
    }
  };

  // Load notifications
  const loadNotifications = async () => {
    try {
      const notificationsData = await notificationsAPI.getNotifications();
      setNotifications(notificationsData);
    } catch (error) {
      console.error('Failed to load notifications:', error);
    }
  };

  // NEW: Load token packages
  const loadTokenPackages = async () => {
    try {
      const packages = await tokenAPI.getTokenPackages();
      setTokenPackages(packages);
    } catch (error) {
      console.error('Failed to load token packages:', error);
    }
  };

  // NEW: Load user's purchases
  const loadMyPurchases = async () => {
    try {
      const purchases = await shopAPI.getMyPurchases();
      setMyPurchases(purchases);
    } catch (error) {
      console.error('Failed to load purchases:', error);
    }
  };

  // NEW: Load token history
  const loadTokenHistory = async () => {
    try {
      const history = await tokenAPI.getTokenHistory();
      setTokenHistory(history);
    } catch (error) {
      console.error('Failed to load token history:', error);
    }
  };

  // Filter countries based on search
  const filteredCountries = countryCodes.filter(country =>
    country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
    country.code.includes(countrySearch)
  );

  // Close dropdowns when clicking outside (keep existing)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setNotificationsOpen(false);
      }
      if (cartRef.current && !cartRef.current.contains(event.target)) {
        setCartOpen(false);
      }
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
        setCountryDropdownOpen(false);
        setCountrySearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
    setCartOpen(false);
  };

  const toggleCart = () => {
    setCartOpen(!cartOpen);
    setNotificationsOpen(false);
  };

  const toggleCountryDropdown = () => {
    setCountryDropdownOpen(!countryDropdownOpen);
    if (!countryDropdownOpen) {
      setCountrySearch('');
    }
  };

  const selectCountryCode = (country) => {
    setSelectedCountryCode(country);
    setCountryDropdownOpen(false);
    setCountrySearch('');
  };

  // UPDATED: Cart functions with Creative Token integration
  const addToCart = async (item) => {
    try {
      if (item.is_purchased) {
        alert('You already own this item!');
        return;
      }
      
      if (!item.can_afford) {
        alert(`You need ${item.token_price} Creative Tokens to purchase this item. You currently have ${user?.profile?.creative_tokens || 0} tokens.`);
        return;
      }

      await cartAPI.addToCart(item.id, 1);
      await loadCart();
      
      // Show success message
      alert(`${item.name} added to cart for ${item.token_price} Creative Tokens!`);
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  const updateCartItemQuantity = async (itemId, newQuantity) => {
    try {
      if (newQuantity <= 0) {
        await cartAPI.removeCartItem(itemId);
      } else {
        await cartAPI.updateCartItem(itemId, newQuantity);
      }
      await loadCart();
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  const removeFromCart = async (itemId) => {
    try {
      await cartAPI.removeCartItem(itemId);
      await loadCart();
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  const clearCart = async () => {
    try {
      await cartAPI.clearCart();
      await loadCart();
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  // UPDATED: Checkout with Creative Tokens
  const handleCheckout = async () => {
    try {
      if (!cart.can_afford) {
        alert(`Insufficient Creative Tokens! You need ${cart.total_token_price} tokens but have ${user?.profile?.creative_tokens || 0} tokens.`);
        return;
      }

      const result = await cartAPI.checkout();
      await loadCart();
      await loadUserProfile(); // Reload to get updated token balance
      await loadMyPurchases(); // Reload purchases
      
      alert(`Checkout successful! You spent ${result.total_tokens_spent} Creative Tokens and now have ${result.remaining_tokens} tokens remaining.`);
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  // NEW: Purchase Creative Tokens
  const purchaseTokens = async (packageId) => {
    try {
      const result = await tokenAPI.purchaseTokens(packageId);
      await loadUserProfile(); // Reload to get updated token balance
      await loadTokenHistory(); // Reload token history
      
      alert(`Success! You purchased ${result.tokens_added} Creative Tokens. Your new balance is ${result.new_balance} tokens.`);
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  // NEW: Download purchased item
  const downloadItem = async (purchaseId) => {
    try {
      const result = await shopAPI.downloadItem(purchaseId);
      
      // Open download link in new tab
      window.open(result.download_url, '_blank');
      
      alert(`Download started! Downloads remaining: ${result.downloads_remaining}`);
      await loadMyPurchases(); // Reload to update download counts
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  // Notification functions (keep existing)
  const markAsRead = async (notificationId) => {
    try {
      await notificationsAPI.markAsRead(notificationId);
      setNotifications(prev => 
        prev.map(notif => 
          notif.id === notificationId ? { ...notif, is_read: true } : notif
        )
      );
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
    }
  };

  const markAllAsRead = async () => {
    try {
      await notificationsAPI.markAllAsRead();
      setNotifications(prev => 
        prev.map(notif => ({ ...notif, is_read: true }))
      );
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
    }
  };

  const clearNotification = (notificationId) => {
    setNotifications(prev => 
      prev.filter(notif => notif.id !== notificationId)
    );
  };

  const unreadCount = notifications.filter(notif => !notif.is_read).length;

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle className="notification-type-icon text-green-500" />;
      case 'warning':
        return <AlertCircle className="notification-type-icon text-yellow-500" />;
      case 'info':
      default:
        return <Info className="notification-type-icon text-blue-500" />;
    }
  };

  // Function to handle project click
  const handleProjectClick = (projectId) => {
    navigate(`/project/${projectId}`);
  };

  // Function to handle redeem token click
  const handleRedeemToken = () => {
    setActiveTab('billing');
  };

  // Function to handle profile click
  const handleProfileClick = () => {
    setActiveTab('profile');
  };

  // Update profile
  const updateProfile = async (profileData) => {
    try {
      await userAPI.updateProfile(profileData);
      await loadUserProfile();
      alert('Profile updated successfully!');
    } catch (error) {
      setError(handleAPIError(error));
    }
  };

  // Logout function
  const handleLogout = () => {
    authAPI.logout();
  };

  // Loading state
  if (loading) {
    return (
      <div className="dashboard-wrapper">
        <div className="loading-container">
          <Loader className="animate-spin" size={32} />
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="dashboard-wrapper">
        <div className="error-container">
          <AlertCircle size={32} />
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      </div>
    );
  }

  const renderDashboardHome = () => (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div>
          <h1>Welcome back, {user?.user?.first_name || user?.user?.username || 'User'}!</h1>
          <p>Here's what's happening with your creative projects today.</p>
        </div>
      </div>

      <div className="stats-overview">
        <div className="stat-card tokens">
          <div className="stat-info">
            <h3>Current Plan</h3>
            <div className="stat-text">{user?.profile?.current_plan || 'Free'}</div>
            <button className="upgrade-btn" onClick={() => setActiveTab('billing')}>Upgrade</button>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-info">
            <h3>Active Projects</h3>
            <div className="stat-number">{stats?.active_projects || 0}</div>
            <p>In progress</p>
          </div>
        </div>
        
        <div className="stat-card rainbow">
          <div className="stat-info">
            <h3>Creative Tokens</h3>
            <div className="stat-number">{stats?.tokens_left || 0}
              <img src={creativetokens} alt='Creative Tokens' style={{ width: "30px", objectFit: "contain" }}/>
            </div>
            <p>Available for use</p>
          </div>
        </div>

        {/* <div className="stat-card">
          <div className="stat-info">
            <h3>Shop Purchases</h3>
            <div className="stat-number">{stats?.shop_purchases || 0}</div>
            <p>Items owned</p>
          </div>
        </div> */}
      </div>

      <div className="quick-actions">
        <Link to='/createprojectform'>
          <button className="action-btn primary">Start New Project</button>
        </Link>
        <button className="action-btn secondary" onClick={handleRedeemToken}>Buy Tokens</button>
        <button className="action-btn outline" onClick={() => setActiveTab('shop')}>Browse Shop</button>
      </div>

      <div className='recent-recommend'>
      <div className="recent-projects">
          <div className="section-header">
            <h2>Recent Projects</h2>
            <button className="view-all-btn" onClick={() => setActiveTab('projects')}>View All</button>
          </div>
          <div className="projects-list">
            {projects.slice(0, 3).map(project => (
              <div key={project.id} className="project-item" onClick={() => handleProjectClick(project.id)} style={{ cursor: 'pointer' }}>
                <div className="project-details">
                  <h4>{project.title}</h4>
                  <span className="project-time">{new Date(project.created_at).toLocaleDateString()}</span>
                </div>
                <div className="project-status">
                  <span className={`status-tag ${project.status.toLowerCase().replace(' ', '-')}`}>
                    {project.status}
                  </span>
                  <button className="more-btn" onClick={(e) => { e.stopPropagation(); }}>⋯</button>
                </div>
              </div>
            ))}
          </div>
        </div>

      <div className="recommend-projects">
        <div className="section-header">
          <div>
            <h2>Recommendations</h2>
            <p>Personalized suggestions based on your creative preferences.</p>
          </div>
        </div>

        <div className="recommendations-grid">
          {mockData.recommendations.map(item => (
            <div key={item.id} className="recommendation-item">
              <img src={item.image} alt={item.name} className="recommendation-image" />
              <div className="recommendation-details">
                <h4>{item.name}</h4>
                <p>{item.description}</p>
                <button className="learn-more-btn">Learn More</button>
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>

    </div>
  );

  // UPDATED: Shop with Creative Token pricing
  const renderShop = () => (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div>
          <h1>Creative Shop</h1>
          <p>Purchase items with Creative Tokens. You have <strong>{user?.profile?.creative_tokens || 0}</strong> tokens available.</p>
        </div>
       <button className="action-btn primary" onClick={() => {
  setActiveTab('billing');
  setShowSubscriptionPlans(false);
  setShowTokenPackages(true);
}}>
  <Coins size={16} />
  Buy More Tokens
</button>
      </div>

      <div className="shop-filters">
        <button 
          className={`filter-btn ${selectedCategory === 'all' ? 'active' : ''}`}
          onClick={() => {
            setSelectedCategory('all');
            loadShopItems();
          }}
        >
          All
        </button>
        <button 
          className={`filter-btn ${selectedCategory === 'templates' ? 'active' : ''}`}
          onClick={() => {
            setSelectedCategory('templates');
            loadShopItems();
          }}
        >
          Templates
        </button>
        <button 
          className={`filter-btn ${selectedCategory === 'assets' ? 'active' : ''}`}
          onClick={() => {
            setSelectedCategory('assets');
            loadShopItems();
          }}
        >
          Assets
        </button>
        <button 
          className={`filter-btn ${selectedCategory === 'tools' ? 'active' : ''}`}
          onClick={() => {
            setSelectedCategory('tools');
            loadShopItems();
          }}
        >
          Tools
        </button>
        <button 
          className={`filter-btn ${selectedCategory === 'graphics' ? 'active' : ''}`}
          onClick={() => {
            setSelectedCategory('graphics');
            loadShopItems();
          }}
        >
          Graphics
        </button>
      </div>

      <div className="shop-grid">
        {shopItems.map(item => (
          <div key={item.id} className={`shop-item ${item.is_purchased ? 'purchased' : ''}`}>
            <div className="shop-image-container">
              <img 
                src={item.image || `https://via.placeholder.com/280x200/f8f9fa/333?text=${encodeURIComponent(item.name)}`} 
                alt={item.name} 
                className="shop-image" 
              />
              {/* {item.is_featured && <div className="featured-badge">Featured</div>} */}
              {item.is_purchased && <div className="purchased-badge">Owned</div>}
            </div>
            <div className="shop-details">
              <h4>{item.name}</h4>
              <p className="shop-description">{item.description}</p>
              
              <div className="shop-meta">
                <span className="shop-category">{item.category}</span>
                {item.rating > 0 && (
                  <div className="shop-rating">
                    <Star size={14} fill="gold" />
                    <span>{item.rating}</span>
                  </div>
                )}
              </div>

              <div className="shop-info">
                {item.file_format && <span className="file-format">{item.file_format}</span>}
                {item.file_size && <span className="file-size">{item.file_size}</span>}
              </div>

              <div className="shop-pricing">
                <div className="token-price">
                  <img src={creativetokens} alt="Creative Tokens" style={{ width: "16px" }} />
                  <span>{item.token_price} Tokens</span>
                </div>
                {item.original_price && (
                  <div className="original-price">${item.original_price}</div>
                )}
              </div>

              {item.is_purchased ? (
                <button className="purchased-btn" disabled>
                  ✓ Purchased
                </button>
              ) : (
                <button 
                  className={`add-to-cart-btn ${!item.can_afford ? 'insufficient-tokens' : ''}`}
                  onClick={() => addToCart(item)}
                  disabled={!item.can_afford}
                >
                  {item.can_afford ? (
                    <>
                      <ShoppingCart size={16} />
                      Add to Cart
                    </>
                  ) : (
                    'Insufficient Tokens'
                  )}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // NEW: My Purchases section
  const renderMyPurchases = () => (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div>
          <h1>My Purchases</h1>
          <p>Items you've purchased with Creative Tokens.</p>
        </div>
      </div>

      {myPurchases.length === 0 ? (
        <div className="empty-state">
          <ShoppingBag size={48} className="opacity-50" />
          <h3>No purchases yet</h3>
          <p>Start shopping to see your purchased items here.</p>
          <button className="action-btn primary" onClick={() => setActiveTab('shop')}>
            Browse Shop
          </button>
        </div>
      ) : (
        <div className="purchases-grid">
          {myPurchases.map(purchase => (
            <div key={purchase.id} className="purchase-item">
              <img 
                src={purchase.shop_item.image || `https://via.placeholder.com/200x150/f8f9fa/333?text=${encodeURIComponent(purchase.shop_item.name)}`}
                alt={purchase.shop_item.name}
                className="purchase-image"
              />
              <div className="purchase-details">
                <h4>{purchase.shop_item.name}</h4>
                <p>{purchase.shop_item.description}</p>
                
                <div className="purchase-meta">
                  <span className="tokens-spent">
                    <img src={creativetokens} alt="Tokens" style={{ width: "14px" }} />
                    {purchase.tokens_spent} tokens
                  </span>
                  <span className="purchase-date">
                    {new Date(purchase.purchase_date).toLocaleDateString()}
                  </span>
                </div>

                <div className="download-info">
                  <span>Downloads: {purchase.download_count}/{purchase.max_downloads}</span>
                  {purchase.shop_item.file_format && (
                    <span>Format: {purchase.shop_item.file_format}</span>
                  )}
                  {purchase.shop_item.file_size && (
                    <span>Size: {purchase.shop_item.file_size}</span>
                  )}
                </div>

                <button 
                  className={`download-btn ${!purchase.can_download ? 'disabled' : ''}`}
                  onClick={() => downloadItem(purchase.id)}
                  disabled={!purchase.can_download}
                >
                  <Download size={16} />
                  {purchase.can_download ? 'Download' : 'Download Limit Reached'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  const renderProjects = () => (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div>
          <h1>My Projects</h1>
        </div>
        <Link to='/createprojectform'>
          <button className="action-btn primary">New Project</button>
        </Link>
      </div>

      <div className="projects-table">
        {projects.map(project => (
          <div key={project.id} className="project-row" onClick={() => handleProjectClick(project.id)} style={{ cursor: 'pointer' }}>
            <div className="project-info">
              <h4>{project.title}</h4>
              <span className="project-modified">{new Date(project.created_at).toLocaleDateString()}</span>
            </div>
            <div className="project-actions">
              <span className={`status-badge ${project.status.toLowerCase().replace(' ', '-')}`}>
                {project.status}
              </span>
              <button className="action-menu" onClick={(e) => { e.stopPropagation(); }}>⋯</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );


const renderBilling = () => {
  return (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div>
          <h1>Billing & Subscription</h1>
          <p>Manage your subscription and view usage statistics.</p>
        </div>
      </div>

      <div className="billing-cards">
        <div className="billing-card">
          <h3>Current Plan</h3>
          <h2>{currentSubscription?.plan || user?.profile?.current_plan || 'Free'}</h2>
          {currentSubscription?.status === 'active' && currentSubscription?.end_date && (
            <p className="subscription-status">
              Active until: {new Date(currentSubscription.end_date).toLocaleDateString()}
            </p>
          )}
          
          <div className="plan-actions">
            <button
              className="action-btn primary"
              onClick={() => {
                // Close token packages if open, then toggle subscription plans
                setShowTokenPackages(false);
                setShowSubscriptionPlans(!showSubscriptionPlans);
              }}
            >
              {currentSubscription?.plan === 'Free' || !currentSubscription ? 'Upgrade Plan' : 'Change Plan'}
            </button>
            
            {currentSubscription && currentSubscription.plan !== 'Free' && currentSubscription.status === 'active' && (
              <button
                className="action-btn secondary"
                onClick={cancelSubscription}
                style={{ marginLeft: '10px' }}
              >
                Cancel Plan
              </button>
            )}
          </div>
        </div>

        <div className="billing-card">
          <h3>Token Usage</h3>
          <div className="usage-details">
            <div className="usage-bar">
              <div className="usage-progress" style={{width: '68%'}}></div>
            </div>
            <p>{stats?.tokens_left || 0} tokens remaining</p>
          </div>
          <button
            className="action-btn primary"
            onClick={() => {
              // Close subscription plans if open, then toggle token packages
              setShowSubscriptionPlans(false);
              setShowTokenPackages(!showTokenPackages);
            }}
          >
            Buy Tokens
          </button>
        </div>
      </div>

      {/* Subscription Plans Section */}
      {showSubscriptionPlans && (
        <div className="subscription-plans-container">
          <div className="section-header">
            <h2>Subscription Plans</h2>
            <p style={{ color: 'white' }}>*Choose a plan that fits your creative needs</p>
          </div>

          <div className="subscription-plans-grid">
            {subscriptionPlans.map(plan => (
              <div key={plan.id} className={`subscription-plan ${plan.is_popular ? 'popular' : ''} ${currentSubscription?.plan === plan.name.toLowerCase() ? 'current-plan' : ''}`}>
                {plan.is_popular && <div className="popular-badge">Most Popular</div>}
                {currentSubscription?.plan === plan.name.toLowerCase() && <div className="current-badge">Current Plan</div>}

                <div className="plan-header">
                  <h3>{plan.name}</h3>
                  <div className="plan-price">
                    {plan.price === 0 ? 'Free' : `$${plan.price}`}
                    {plan.price > 0 && <span className="billing-period">/{plan.billing_period}</span>}
                  </div>
                </div>

                <div className="plan-features">
                  <ul>
                    {plan.features.map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="plan-benefits">
                  {plan.monthly_tokens && (
                    <div className="token-benefit">
                      <img src={creativetokens} alt="Tokens" style={{ width: "16px" }} />
                      <span>{plan.monthly_tokens} tokens/month</span>
                    </div>
                  )}
                  {plan.project_limit && (
                    <div className="project-benefit">
                      📁 {plan.project_limit === -1 ? 'Unlimited' : plan.project_limit} projects
                    </div>
                  )}
                </div>

                <button
                  className={`action-btn ${currentSubscription?.plan === plan.name.toLowerCase() ? 'current' : 'primary'}`}
                  onClick={() => currentSubscription?.plan !== plan.name.toLowerCase() && subscribeToPlan(plan.id)}
                  disabled={currentSubscription?.plan === plan.name.toLowerCase()}
                >
                  {currentSubscription?.plan === plan.name.toLowerCase() ? 'Current Plan' : 
                   plan.price === 0 ? 'Downgrade to Free' : 'Subscribe Now'}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Token Packages Section */}
      {showTokenPackages && (
        <div className="token-packages-container">
          <div className="section-header">
            <h2>Token Packages</h2>
            <p style={{ color: 'white' }}>*Choose a package that fits your creative needs</p>
          </div>

          <div className="token-packages-grid">
            {tokenPackages.map(pkg => (
              <div key={pkg.id} className={`token-package ${pkg.is_popular ? 'popular' : ''}`}>
                {pkg.is_popular && <div className="popular-badge">Most Popular</div>}

                <div className="package-header">
                  <h3>{pkg.name}</h3>
                  <div className="package-price">${pkg.price}</div>
                </div>

                <div className="package-details">
                  <div className="token-breakdown">
                    <div className="base-tokens">{pkg.tokens} Base Tokens</div>
                    {pkg.bonus_tokens > 0 && (
                      <div className="bonus-tokens">+ {pkg.bonus_tokens} Bonus Tokens</div>
                    )}
                    <div className="total-tokens">= {pkg.total_tokens} Total Tokens</div>
                  </div>
                  <div className="value-info">
                    <span>${pkg.value_per_token.toFixed(3)} per token</span>
                  </div>
                  {pkg.description && (
                    <p className="package-description">{pkg.description}</p>
                  )}
                </div>

                <button
                  className="action-btn primary"
                  onClick={() => purchaseTokens(pkg.id)}
                >
                  Purchase Package
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Subscription History Section */}
      {subscriptionHistory && subscriptionHistory.length > 0 && (
        <div className="subscription-history-container">
          <div className="section-header">
            <h2>Subscription History</h2>
          </div>
          <div className="history-list">
            {subscriptionHistory.map((sub, index) => (
              <div key={index} className="history-item">
                <div className="history-details">
                  <h4>{sub.plan}</h4>
                  <p>{new Date(sub.start_date).toLocaleDateString()} - {sub.end_date ? new Date(sub.end_date).toLocaleDateString() : 'Present'}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

  const renderProfile = () => (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div>
          <h1>Profile Settings</h1>
          <p>Manage your account information and preferences.</p>
        </div>
      </div>

      <div className="profile-form">
        <div className="form-section">
          <h3>Personal Information</h3>
          
          <div className='form-divide'>
            <div className='form-left'>
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" defaultValue={`${user?.user?.first_name || ''} ${user?.user?.last_name || ''}`} />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" defaultValue={user?.user?.email || ''} />
              </div>
              <div className="form-group">
                <label>Contact No.</label>
                <div className="contact-input-container">
                  <div className="country-code-selector" ref={countryDropdownRef}>
                    <button 
                      type="button"
                      className="country-code-button"
                      onClick={toggleCountryDropdown}
                    >
                      <span className="flag">{selectedCountryCode.flag}</span>
                      <span className="code">{selectedCountryCode.code}</span>
                      <ChevronDown size={14} className={`chevron ${countryDropdownOpen ? 'open' : ''}`} />
                    </button>
                    
                    {countryDropdownOpen && (
                      <div className="country-dropdown">
                        <div className="country-dropdown-header">
                          <input 
                            type="text" 
                            placeholder="Search countries..."
                            className="country-search"
                            value={countrySearch}
                            onChange={(e) => setCountrySearch(e.target.value)}
                          />
                        </div>
                        <div className="country-options">
                          {filteredCountries.length > 0 ? (
                            filteredCountries.map((country, index) => (
                              <div 
                                key={`${country.code}-${country.country}-${index}`}
                                className="country-option"
                                onClick={() => selectCountryCode(country)}
                              >
                                <span className="flag">{country.flag}</span>
                                <span className="country-name">{country.name}</span>
                                <span className="country-code">{country.code}</span>
                              </div>
                            ))
                          ) : (
                            <div className="no-results">
                              <p>No countries found</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <input 
                    type="tel" 
                    className="contact-number-input"
                    value={contactNumber}
                    onChange={(e) => setContactNumber(e.target.value)}
                    placeholder="Enter phone number"
                  />
                </div>
              </div>
            </div>

            <div className='form-right'>
              <div className="form-group">
                <label>Company Name</label>
                <input type="text" defaultValue={user?.profile?.company_name || ''} />
              </div>
              <div className="form-group">
                <label>Company Email</label>
                <input type="email" defaultValue={user?.profile?.company_email || ''} />
              </div>
              <div className="form-group">
                <label>Company Website</label>
                <input type="url" defaultValue={user?.profile?.company_website || ''} />
              </div>
            </div>
          </div>

          <button className="action-btn primary" onClick={() => updateProfile({})}>Update Profile</button>
          <button className="action-btn secondary" onClick={handleLogout} style={{marginLeft: '10px'}}>Logout</button>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch(activeTab) {
      case 'dashboard': return renderDashboardHome();
      case 'shop': return renderShop();
      case 'my-purchases': return renderMyPurchases();
      case 'recommendations': return renderRecommendations();
      case 'projects': return renderProjects();
      case 'billing': return renderBilling();
      case 'profile': return renderProfile();
      default: return renderDashboardHome();
    }
  };

  const renderRecommendations = () => (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div>
          <h1>Recommendations</h1>
          <p>Personalized suggestions based on your creative preferences.</p>
        </div>
      </div>
      <div className="recommendations-grid">
          {mockData.recommendations.map(item => (
            <div key={item.id} className="recommendation-item">
              <img src={item.image} alt={item.name} className="recommendation-image" />
              <div className="recommendation-details">
                <h4>{item.name}</h4>
                <p>{item.description}</p>
                <button className="learn-more-btn">Learn More</button>
              </div>
            </div>
          ))}
        </div>
    </div>
  );

  return (
    <div className="dashboard-wrapper">
      {/* Mobile Overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
      
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo-container">
            <Link to='/'>
              <img src={redfibrelogo} alt='Red Fibre Logo' style={{ width:"20px" }}/>
            </Link>
          </div>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map(item => {
            const IconComponent = item.icon;
            return (
              <button
                key={item.id}
                className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(item.id);
                  setSidebarOpen(false);
                }}
              >
                <IconComponent className="nav-icon" />
                <span className="nav-label">{item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Top Bar */}
        <div className="topbar">
          <div className="topbar-left">
            <button className="menu-toggle" onClick={toggleSidebar}>
              <Menu size={18} />
            </button>
          </div>
          <div className="topbar-right">
            {/* Creative Tokens with Tooltip */}
            <div className="creative-token-container">
              <button className="notification-btn">
                <img src={creativetokens} alt='Creative Tokens' className='creative-token'/>
                <span className="notification-creative">{stats?.tokens_left || 0}</span>
              </button>
              <div className="creative-token-tooltip">
                Pay once. Use anytime. Creative Tokens are your flexible, on-demand credits for accessing quick designs, micro tasks, and creative services—without any subscription.
              </div>
            </div>

            {/* Cart Container - Updated with token pricing */}
            <div className="notification-container" ref={cartRef}>
              <button className="notification-btn" onClick={toggleCart}>
                <ShoppingCart size={26} />
                {cart.total_items > 0 && (
                  <span className="notification-badge">{cart.total_items}</span>
                )}
              </button>
              
              {/* Cart Dropdown */}
              {cartOpen && (
                <div className="cart-dropdown">
                  <div className="cart-header">
                    <h3>Shopping Cart</h3>
                    <div className="cart-actions">
                      {cart.items.length > 0 && (
                        <button onClick={clearCart} className="clear-cart">
                          Clear all
                        </button>
                      )}
                      <button onClick={toggleCart} className="close-cart">
                        <X size={16} />
                      </button>
                    </div>
                  </div>
                  
                  <div className="cart-list">
                    {cart.items.length === 0 ? (
                      <div className="empty-cart">
                        <ShoppingCart size={24} className="opacity-50" />
                        <p>Your cart is empty</p>
                      </div>
                    ) : (
                      cart.items.map(item => (
                        <div key={item.id} className="cart-item">
                          <img 
                            src={item.shop_item.image || "https://via.placeholder.com/60x60"} 
                            alt={item.shop_item.name} 
                            className="cart-item-image" 
                          />
                          <div className="cart-item-details">
                            <h4>{item.shop_item.name}</h4>
                            <div className="cart-item-price">
                              <img src={creativetokens} alt="Tokens" style={{ width: "14px" }} />
                              <span>{item.shop_item.token_price} tokens</span>
                            </div>
                            <div className="quantity-controls">
                              <button 
                                onClick={() => updateCartItemQuantity(item.id, item.quantity - 1)}
                                className="quantity-btn"
                              >
                                <Minus size={14} />
                              </button>
                              <span className="quantity">{item.quantity}</span>
                              <button 
                                onClick={() => updateCartItemQuantity(item.id, item.quantity + 1)}
                                className="quantity-btn"
                              >
                                <Plus size={14} />
                              </button>
                            </div>
                          </div>
                          <button 
                            className="remove-item"
                            onClick={() => removeFromCart(item.id)}
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                  
                  {cart.items.length > 0 && (
                    <div className="cart-footer">
                      <div className="cart-total">
                        <div className="token-total">
                          <img src={creativetokens} alt="Tokens" style={{ width: "16px" }} />
                          <strong>{cart.total_token_price} Tokens</strong>
                        </div>
                        <div className="affordability-status">
                          {cart.can_afford ? (
                            <span className="can-afford">✓ You can afford this</span>
                          ) : (
                            <span className="cannot-afford">
                              ⚠ Need {cart.total_token_price - (user?.profile?.creative_tokens || 0)} more tokens
                            </span>
                          )}
                        </div>
                      </div>
                      <button 
                        className={`checkout-btn ${!cart.can_afford ? 'insufficient-tokens' : ''}`}
                        onClick={handleCheckout}
                        disabled={!cart.can_afford}
                      >
                        {cart.can_afford ? 'Checkout with Tokens' : 'Insufficient Tokens'}
                      </button>
                      {!cart.can_afford && (
                        <button 
                          className="buy-tokens-btn"
                          onClick={() => {
                            setCartOpen(false);
                            setActiveTab('billing');
                            setShowSubscriptionPlans(false);
                            setShowTokenPackages(true);
                          }}
                        >
                          Buy More Tokens
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Notifications */}
            <div className="notification-container" ref={notificationRef}>
              <button className="notification-btn" onClick={toggleNotifications}>
                <Bell size={26} />
                {unreadCount > 0 && (
                  <span className="notification-badge">{unreadCount}</span>
                )}
              </button>
              
              {/* Notification Dropdown */}
              {notificationsOpen && (
                <div className="notification-dropdown">
                  <div className="notification-header">
                    <h3>Notifications</h3>
                    <div className="notification-actions">
                      {unreadCount > 0 && (
                        <button onClick={markAllAsRead} className="mark-all-read">
                          Mark all read
                        </button>
                      )}
                      <button onClick={toggleNotifications} className="close-notifications">
                        <X size={16} />
                      </button>
                    </div>
                  </div>
                  
                  <div className="notification-list">
                    {notifications.length === 0 ? (
                      <div className="no-notifications">
                        <Bell size={24} className="opacity-50" />
                        <p>No notifications</p>
                      </div>
                    ) : (
                      notifications.map(notification => (
                        <div 
                          key={notification.id} 
                          className={`notification-item ${!notification.is_read ? 'unread' : ''}`}
                          onClick={() => markAsRead(notification.id)}
                        >
                          <div className="notification-icon">
                            {getNotificationIcon(notification.type)}
                          </div>
                          <div className="notification-content">
                            <h4>{notification.title}</h4>
                            <p>{notification.message}</p>
                            <span className="notification-time">{new Date(notification.created_at).toLocaleDateString()}</span>
                          </div>
                          <button 
                            className="notification-close"
                            onClick={(e) => {
                              e.stopPropagation();
                              clearNotification(notification.id);
                            }}
                          >
                            <X size={14} />
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
            </div>
            
            <div className="profile-dropdown" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
              <img src={user?.profile?.avatar || "https://via.placeholder.com/40x40/ff0033/ffffff?text=" + (user?.user?.username?.charAt(0) || 'U')} alt="Profile" className="profile-pic" />
              <span className="profile-name">{user?.user?.first_name || user?.user?.username || 'User'}</span>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <div className="page-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default Dashboard2;